// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".common_font_line[data-v-5b1b4a9f]{display:flex;align-items:center;justify-content:center;height:17px;font-size:12px;font-weight:400;line-height:17px;color:#999;text-align:center}.common_font_line .font[data-v-5b1b4a9f]{position:relative;padding:0 16px}.common_font_line .line[data-v-5b1b4a9f]{display:inline-block;height:1px;background-color:#999}", ""]);
// Exports
module.exports = exports;
